import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from "@progress/kendo-react-inputs";
import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";

import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  ActiveInactiveGallery,
  deleteGallery,
  getAllGallerys,
} from "./services/gallery.services";
import { clearGalleryID, setGalleryID } from "./gallerySlice";
import { Tooltip } from "@mui/material";
// import { FaGraduationCap } from "react-icons/fa6";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import IconButton from "../../components/common/IconButton";
import { FaGraduationCap } from "react-icons/fa";

const Gallery: React.FC = () => {
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  // const handleCreate = () => {
  //   navigate("/gallery/create");
  // };

  useEffect(() => {
    dispatch(getAllGallerys());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  return (
    <>
      <DeleteGalleryDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Gallery List
          </Typography.h4>
          {isAddAccess && (
            // <Button
            //   onClick={handleCreate}
            //   fillMode={"solid"}
            //   themeColor={"primary"}
            // >
            //   {"Create Gallery"}
            // </Button>
            <ButtonCreate label="Create Gallery" drawerName="galleryForm" />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <GalleryGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const GalleryGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const GalleryList = useAppSelector((state) => state.gallery.GalleryList);
  const loading = useAppSelector((state) => state.gallery.loading);

  useEffect(() => {
    dispatch(getAllGallerys());
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? GalleryList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    // const handleEdit = (ID: number) => {
    //   navigate("/gallery/edit", { state: { GalleryID: ID } });
    // };
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteGallery"));
      dispatch(setGalleryID(ID));
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.ID}
            drawerName="galleryForm"
            tooltipTitle="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 2 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(
      props.dataItem.IsActive ?? false,
    );

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveGallery(data)).then((response: any) => {
        // dispatch(getAllGallerys());
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllGallerys());
        } else {
          dispatch(getAllGallerys());
        }
      });
    };

    return (
      <td
        style={{ textAlign: "center", ...props.style }}
        className={props.className}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {GalleryList && GalleryList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          filterable={true}
          filter={filter}
          className="responsive-table"
          data={
            filter
              ? filterBy(GalleryList, filter).slice(
                  page.skip,
                  page.take + page.skip,
                )
              : GalleryList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={GalleryList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="ImgAlt"
            title="Img Alt"
            width={250}
            cell={(props: any) => (
              <td>
                <div className="hoverableName">
                  {isEditAccess ? (
                    <ButtonEdit
                      ID={props.dataItem.ID}
                      drawerName="galleryForm"
                      label={props.dataItem?.ImgAlt}
                    />
                  ) : (
                    <div className="normalName">{props.dataItem?.ImgAlt}</div>
                  )}
                </div>
              </td>
            )}
          />
          <Column
            field="GalleryImage"
            title="Image"
            width={100}
            filterable={false}
            cells={{
              data: (props: any) => (
                <td style={{ textAlign: "center" }}>
                  <Avatar
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      height: "100%",
                      flexBasis: 45,
                      backgroundColor: "white",
                    }}
                    rounded={"medium"}
                    type={"image"}
                  >
                    <Tooltip
                      placement="left"
                      title={
                        <img
                          style={{
                            padding: "5px",
                            backgroundColor: "white",
                            height: 150,
                          }}
                          src={props.dataItem?.GalleryImage}
                          alt="Gallery Image"
                          width="100%"
                          onClick={() =>
                            window.open(props.dataItem?.GalleryImage)
                          }
                        />
                      }
                    >
                      {props.dataItem?.GalleryImage ? (
                        <img
                          style={{ padding: "10px" }}
                          src={props.dataItem?.GalleryImage}
                          alt="Gallery Image"
                          onClick={() =>
                            window.open(props.dataItem?.GalleryImage)
                          }
                        />
                      ) : (
                        <IconButton
                          type="button"
                          fillMode="flat"
                          size="small"
                          icon={FaGraduationCap}
                          iconStyle={{
                            fontSize: "50px",
                            background: "lightgray",
                            padding: "5px",
                            borderRadius: "4px",
                            color: "#163064",
                          }}
                        />
                      )}
                    </Tooltip>
                  </Avatar>
                </td>
              ),
            }}
          />
          <Column
            field="ID"
            title="Status"
            cells={{ data: MyActiveInActtiveCommandCell }}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isEditAccess || isDeleteAccess) && (
            <Column
              field="ID"
              title="Actions"
              cells={{ data: MyEditCommandCell }}
              width={"110px"}
              locked={true}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

const DeleteGalleryDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const GalleryID = useAppSelector((state) => state.gallery.GalleryID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteGallery(ID));
      if (response.payload.Data.Status === 200) {
        dispatch(getAllGallerys());
        dispatch(closeDialog());
        dispatch(clearGalleryID());
      } else {
        dispatch(getAllGallerys());
        dispatch(closeDialog());
        dispatch(clearGalleryID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteGallery" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Gallery"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this gallery ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(GalleryID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Gallery;
